import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { TransparenciaLayoutComponent } from './layout/transparencia-layout/transparencia-layout.component';
import { internalDomainGuard } from './_infrastructure/guards/InternalDomainGuard/internal-domain.guard';
import { authGuard } from './_infrastructure/guards/AuthGuard/auth-guard.guard';
import { authInverseGuard } from './_infrastructure/guards/AuthInverseGuard/auth-inverse.guard';
import { moduloRedirectGuard } from './_infrastructure/guards/ModuloRedirectGuard/modulo-redirect.guard';

const routes: Routes = [
  {
    path: '',
    component: TransparenciaLayoutComponent,
    canActivate: [moduloRedirectGuard],
    children: [
      { path: '', redirectTo: '/transparencia', pathMatch: 'full' },
      {
        path: 'transparencia',
        loadChildren: () =>
          import('./transparencia/transparencia.module').then((m) => m.TransparenciaModule),
      }
    ]
  },
  {
    path: 'adm',
    canMatch: [internalDomainGuard],
    canActivate: [authGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./area-administrativa/area-administrativa.module').then(m => m.AreaAdministrativaModule)
      },
      {
        path: 'imap',
        loadChildren: () =>
          import('./imap/imap.module').then((m) => m.ImapModule),
      },
    ]
  },
  {
    path: 'authentication',
    canMatch: [internalDomainGuard],
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { } 